import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
@Component({
  selector: 'app-plan-iptv',
  templateUrl: './plan-iptv.component.html',
  styleUrls: ['./plan-iptv.component.sass']
})
export class PlanIptvComponent implements OnInit {
  @Input() data;
  @Input() itemsCart;
  @Output() selectsToDisplayOut = new EventEmitter<string>();
  @Output() selectsToDisplayFullOut = new EventEmitter<any>();
  @Output() selectMonthlyRentOut = new EventEmitter<number>();
  constructor(public global: GlobalService) { }
  ngOnInit(): void {
    this.exit();
  }
  exit(){
    let nameFullTitle:string="";
    let monthlyRent:number=0;
    let nameFull:string="";
    let countiptv:number=0;
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].plan == true && i == 0) {
        if (countiptv == 0) {
          nameFull = " : " + this.itemsCart.products[i].productName;
          nameFullTitle=nameFull;
          monthlyRent = this.itemsCart.products[i].decTotalPerMonth;
          countiptv++
        }
        if (countiptv == 1) {
          if (this.itemsCart.products[i].offers != null) {
            for (let j = 0; j < this.itemsCart.products[i].offers.length; j++) {
              nameFull += ' | ' + this.global.stringCalculation(this.itemsCart.products[i].offers[j].productName, this.itemsCart.products[i].offers.length, this.global.maximumString);
              nameFullTitle+=' | '+this.itemsCart.products[i].offers[j].productName;
            }
          }
        }
      }
    }
    this.selectsToDisplayOut.emit(nameFull);
    this.selectMonthlyRentOut.emit(monthlyRent);
    this.selectsToDisplayFullOut.emit(nameFullTitle)
  }
}
